export default function ServersDirective() {
  return {
    template: require('./servers.html'),
    scope: {
      assessmentId: '=',
      servers: '=',
      hasNetcomply: '=',
      hasDatto: '=',
      addCallback: '&',
      deleteCallback: '&',
      customerId: '=',
      tooltipAppendToSelector: '@',
      status: '=',
    },
    controller: 'ServersController',
    controllerAs: 'serversVM',
    bindToController: true,
    replace: true,
  };
}
